<template>
<div class="mt-4" v-if="organisation">
    <v-snackbar top v-model="snackbar">
       <v-icon color="success" class="mr-2">check_circle_outline</v-icon>  Successfully copied to clipboard!
        <!-- <v-btn color="primary" flat @click="snackbar = false">X</v-btn> -->
      </v-snackbar>
    <v-toolbar flat color="white">
        <v-avatar size="100px" :tile="true">
            <v-img style="height: 50px" contain v-if="organisation.logo" :src="organisation.logo" />
        </v-avatar>
        <v-toolbar-title>{{organisation.name}}</v-toolbar-title>

    </v-toolbar>
    <v-tabs>
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab v-for="tab in tabs" :key="tab.name" @click="activeTab = tab.name">
            <v-icon size="20px" class="mx-1">{{tab.icon}}</v-icon> {{tab.displayName}}
            <v-chip v-if="tab.name=='serviceAccounts'">{{activeServiceAccounts.count}}</v-chip>
        </v-tab>
    </v-tabs>
    <div v-if="activeTab == 'info'" class="mt-4">
        <v-layout wrap justify-center>
            <v-flex xs12 lg5 ma-1>
                <v-card flat>
                    <h3>
                        Contact Information
                    </h3>
                    <v-card-text>
                        <v-layout wrap justify-start>

                            <v-flex xs6 class="text-xs-left">
                                <h4>Billing Email Address: </h4>
                            </v-flex>
                            <v-flex xs6 class="text-xs-left">
                                <span>{{organisation.billingEmailAddress}}</span>
                            </v-flex>
                            <v-flex xs6 class="text-xs-left">
                                <h4>Sales Email Address: </h4>
                            </v-flex>
                            <v-flex xs6 class="text-xs-left">
                                <span>{{organisation.salesEmailAddress}}</span>
                            </v-flex>
                            <v-flex xs6 class="text-xs-left">
                                <h4>Customer Support Email: </h4>
                            </v-flex>
                            <v-flex xs6 class="text-xs-left">
                                <span>{{organisation.customerSupportEmail}}</span>
                            </v-flex>
                            <v-flex xs6 class="text-xs-left">
                                <h4>Customer Support Phone: </h4>
                            </v-flex>
                            <v-flex xs6 class="text-xs-left">
                                <span>{{organisation.customerSupportTelephone}}</span>
                            </v-flex>
                            <v-flex xs6 class="text-xs-left">
                                <h4>Whatsapp Support: </h4>
                            </v-flex>
                            <v-flex xs6 class="text-xs-left">
                                <span>{{organisation.customerSupportWhatsapp}}</span>
                            </v-flex>
                            <v-flex xs6 class="text-xs-left">
                                <h4>Technical Escalations Number: </h4>
                            </v-flex>
                            <v-flex xs6 class="text-xs-left">
                                <span>{{organisation.technicalEscalationsContactNumber}}</span>
                            </v-flex>
                            <v-flex xs6 class="text-xs-left">
                                <h4>Technical Escalations Email: </h4>
                            </v-flex>
                            <v-flex xs6 class="text-xs-left">
                                <span>{{organisation.technicalEscalationsEmailAddress}}</span>
                            </v-flex>
                            <v-flex xs6 class="text-xs-left" v-if="$store.state.currentOrg.org.applicationURL">
                                <h4>Order Page URL: <v-btn @click="copyReference()" small icon><v-icon small>content_copy</v-icon></v-btn></h4>
                            </v-flex>
                            <v-flex xs6 class="text-xs-left" v-if="$store.state.currentOrg.org.applicationURL">
                                <span>{{$store.state.currentOrg.org.applicationURL}}{{'?isp='}} {{organisation.reference}}</span>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12 lg5 ma-1>
                <documentcomponent :key="key" :customerOrganisationId="$route.params.customerOrganisationId" :documents="documents" @documentChange="fetchDocuments">
                </documentcomponent>
            </v-flex>
        </v-layout>
    </div>

    <div v-else-if="activeTab == 'packages'">
        <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <h3 class="grey--text title">Globally Available Packages</h3>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-flex xs6>
                <v-text-field label="Search" v-model="globalIspPackagesSearch" clearable></v-text-field>
            </v-flex>
        </v-toolbar>
        <v-data-table :items="globalIspPackages" :search="globalIspPackagesSearch" :headers="globalIspPackageHeaders" style="cursor: pointer">
            <template v-slot:items="props">
                <td class="text-xs-center">
                    <v-chip>{{ props.item.packagesFno.type }}</v-chip>
                </td>
                <td class="text-xs-center">{{ props.item.name }}</td>
                <td class="text-xs-center">{{ props.item.packagesFno.packageCode }}</td>

                
                   <td class="text-xs-center">{{ props.item.packagesFno.packageBasePrice |currency }}</td>
                <td class="text-xs-center">
                    {{ props.item.onceOffPriceVatInc | currency }}
                </td>
                <td class="text-xs-center">
                    {{ props.item.recurringPriceVatInc | currency }}
                </td>
             
                <td class="text-xs-center">
                    <v-layout justify-center align-center wrap>
                        <v-icon color="light-green">arrow_drop_down</v-icon>
                        {{ props.item.packagesFno.speedProfile.downloadMbps }}
                        <v-icon color="red">arrow_drop_up</v-icon>
                        {{ props.item.packagesFno.speedProfile.uploadMbps }}
                    </v-layout>
                </td>
                <td class="text-xs-center">
                    {{props.item.activeServiceAccounts}}
                </td>
                <td class="text-xs-center">
                    <v-chip v-if="props.item.isActive" color="light-green" class="white--text">Visible</v-chip>
                    <v-chip v-else color="red" class="white--text">Not Visible</v-chip>
                </td>
            </template>
        </v-data-table>
        <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <h3 class="grey--text title">Network Specific Packages</h3>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-flex xs6>
                <v-text-field label="Search" v-model="networkPackageSearch" clearable></v-text-field>
            </v-flex>
        </v-toolbar>
        <v-data-table :items="networkIspPackages" :search="networkPackageSearch" :headers="networkPackageHeaders" style="cursor: pointer">
            <template v-slot:items="props">
                <td class="text-xs-center">{{ props.item.name }}</td>
                 <td class="text-xs-center">{{ props.item.packagesFno.packageCode }}</td>
                <td class="text-xs-center">{{ props.item.locationNetwork.name }}</td>
                <td class="text-xs-center">{{ props.item.packagesFno.packageBasePrice |currency }}</td>
                <td class="text-xs-center">{{ props.item.recurringPriceVatInc |currency }}</td>


                <td class="text-xs-center">{{ props.item.activeServiceAccounts }}</td>
            </template>
        </v-data-table>
    </div>

    <div v-else-if="activeTab=='serviceAccounts'">
        <v-toolbar flat color="white">
            <v-btn color="primary" round @click="exportActiveData()">Export Data</v-btn>
            <v-spacer></v-spacer>
            <v-text-field v-model="activeSearch" label="Search" v-on:keyup.enter="$router.push({name: $route.name, 
        query:{
          activeOffset: '0',
          records: $route.query.records, 
          activeSearch: activeSearch,
          }})"></v-text-field>
        </v-toolbar>
        <v-data-table :loading="isLoading" :rows-per-page-items="[25, 50, 100, 250, 500, 1000]" :items="activeServiceAccounts.result" :headers="activeHeaders" disable-initial-sort style="cursor: pointer" hide-actions>
            <template v-slot:items="props">
                <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{props.item.circuitNumber}}</td>
                <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{props.item.location.locationDescription}}</td>

                <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{props.item.device.ponMac}}</td>
                <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{formatDate(props.item.fnoActivationDate)}}</td>
                <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{props.item.packagesIsp.customerOrganisation.name}}</td>
                <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{props.item.packagesIsp.packagesFno.speedProfile.downloadMbps}}</td>
                <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{props.item.packagesIsp.packagesFno.speedProfile.uploadMbps}}</td>
                <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
                    <v-chip>{{props.item.packagesIsp.packagesFno.type}}</v-chip>
                </td>
                <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-if="props.item.deviceBridge">
                    <v-icon v-if="props.item.deviceBridge.isActive" color="green">done</v-icon>
                    <v-icon v-else color="red">clear</v-icon>
                </td>
                <td v-else></td>
            </template>
        </v-data-table>
        <div class="text-xs-center pt-2 white" :key="$route.query.activeOffset">
            <v-layout wrap>
                <v-flex xs12>
                    <v-pagination v-model="activePage" :length="Math.ceil(activeServiceAccounts.count/$route.query.records)" :total-visible="7"></v-pagination>
                </v-flex>
            </v-layout>
        </div>
    </div>
</div>
</template>

<script>
import Api from "../services/Api";
import DocumentCard from "@/components/DocumentCard.vue";
import dateformat from "dateformat";
export default {
    components: {
        documentcomponent: DocumentCard,
    },
    data() {
        return {
            activePage: 1,
            activeServiceAccounts: {
                count: 0,
                result: []
            },
            documents: [],
            organisation: {},
            networkIspPackages: [],
            networkPackageSearch: '',
            globalIspPackages: [],
            globalIspPackagesSearch: [],
            activeHeaders: [{
                    text: "Circuit Number",
                    align: "center",
                    value: "circuitNumber"
                },
                {
                    text: "Location",
                    align: "center",
                    value: "location.locationDescription"
                },
                {
                    text: "Device",
                    align: "center",
                    value: "device.ponMac"
                },
                {
                    text: "Date Activated",
                    align: "center",
                    value: "fnoActivationDate"
                },
                {
                    text: "ISP",
                    align: "center",
                    value: "packagesIsp.customerOrganisation.name"
                },

                {
                    text: "Download Mbps",
                    align: "center",
                    value: "packagesIsp.packagesFno.speedProfile.downloadMbps"
                },
                {
                    text: "Upload Mbps",
                    align: "center",
                    value: "packagesIsp.packagesFno.speedProfile.uploadMbps"
                },
                {
                    text: "Type",
                    align: "center",
                    value: "packagesIsp.packagesFno.type",
                    sortable: false
                },
                {
                    text: "Connection Active",
                    align: "center",
                    value: "deviceBridge.isActive"
                }
            ],
            globalIspPackageHeaders: [{
                    text: "Type",
                    align: "center",
                    value: "packagesFno.type",
                    sortable: true,
                },
                {
                    text: "Name",
                    align: "center",
                    value: "name",
                    sortable: true,
                },
                {
                    text: "FNO Package",
                    align: "center",
                    value: "packagesFno.packageCode",
                    sortable: true,
                },
                {
                    text: "FNO Package Price excl. VAT",
                    align: "center",
                    value: "packagesFno.packageBasePrice",
                    sortable: true,
                },
                {
                    text: "Once Off Fee incl. VAT",
                    align: "center",
                    value: "onceOffPriceVatInc",
                    sortable: true,
                },
                {
                    text: "Monthly Price incl. VAT",
                    align: "center",
                    value: "recurringPriceVatInc",
                    sortable: true,
                },
                
                {
                    text: "Speed",
                    align: "center",
                    value: "packagesFno.speedProfile.downloadMbps",
                    sortable: true,
                },
                {
                    text: "Active Service Accounts",
                    align: "center",
                    value: "activeServiceAccounts",
                    sortable: true,
                },
                {
                    text: "Status",
                    align: "center",
                    value: "isActive",
                    sortable: true,
                },
            ],
            networkPackageHeaders: [{
                    text: "Package",
                    align: "center",
                    value: "name",
                },
                {
                    text: "FNO Package",
                    align: "center",
                    value: "packagesFno.packageCode",
                },
                {
                    text: "Network",
                    align: "center",
                    value: "locationNetwork.name",
                },
                {
                    text: "FNO Package Price excl. VAT",
                    align: "center",
                    value: "packagesFno.packageBasePrice",
                },
                {
                    text: "ISP Package Price",
                    align: "center",
                    value: "recurringPriceVatInc",
                },
                {
                    text: "Active Service Accounts",
                    align: "center",
                    value: "activeServiceAccounts"
                },

            ],
            tabs: [{
                    displayName: 'Info',
                    name: 'info',
                    icon: 'info'
                },
                {
                    displayName: 'Packages',
                    name: 'packages',
                    icon: 'bar_chart'
                },
                {
                    displayName: 'Active Service Accounts',
                    name: 'serviceAccounts',
                    icon: 'build'
                }
            ],
            activeTab: 'info',
        snackbar: false
        }
    },
    watch: {
        '$route.query.activeSearch': {
            immediate: true,
            handler(value) {
                this.isLoading = true
                if (this.$route.query.activeSearch && value !== "" && value != null) {
                    this.activePage = 1
                    Api()
                        .get('/supplier/serviceAccounts/AllActive/oneDevice/' + this.$route.params.customerOrganisationId, {
                            params: {
                                search: this.$route.query.activeSearch,
                                offset: '0',
                                records: this.$route.query.records,
                            }
                        })
                        .then(response => {
                            this.activeServiceAccounts = response.data
                            this.isLoading = false
                        })
                } else if (this.$route.query.activeOffset) {
                    Api()
                        .get('/supplier/serviceAccounts/AllActive/oneDevice/' + this.$route.params.customerOrganisationId, {
                            params: {
                                offset: this.$route.query.activeOffset,
                                records: this.$route.query.records,
                            }
                        })
                        .then(response => {
                            this.activeServiceAccounts = response.data
                            this.isLoading = false
                        })
                }
            }
        },
        '$route.query.activeOffset': {
            immediate: true,
            handler(value) {
                this.isLoading = true
                if (value !== "" && value != null && this.$route.query.activeSearch && this.$route.query.activeSearch != "" && this.$route.query.activeSearch !== null) {

                    Api()
                        .get('/supplier/serviceAccounts/AllActive/oneDevice/' + this.$route.params.customerOrganisationId, {
                            params: {
                                search: this.$route.query.activeSearch,
                                offset: this.$route.query.activeOffset,
                                records: this.$route.query.records,
                            }
                        })
                        .then(response => {
                            this.activeServiceAccounts = response.data
                            this.isLoading = false
                        })
                } else if (value != null) {
                    Api()
                        .get('/supplier/serviceAccounts/AllActive/oneDevice/' + this.$route.params.customerOrganisationId, {
                            params: {
                                offset: this.$route.query.activeOffset,
                                records: this.$route.query.records,
                            }
                        })
                        .then(response => {
                            this.activeServiceAccounts = response.data
                            this.isLoading = false
                        })
                }
            }
        },
        activePage(value) {
            // this.activePagination.page = this.activePage;
            if (value && value != "" && value != this.$route.query.records) {
                if (this.$route.query.activeSearch) {
                    this.$router.push({
                        name: this.$route.name,
                        query: {
                            activeOffset: (value - 1) * this.$route.query.records,
                            records: this.$route.query.records,
                            activeSearch: this.$route.query.activeSearch,
                        }
                    });
                } else {
                    this.$router.push({
                        name: this.$route.name,
                        query: {
                            activeOffset: (value - 1) * this.$route.query.records,
                            records: this.$route.query.records
                        }
                    });
                }
            }
        },
    },
    created() {
        this.initialise()
        this.$router.push({
            name: this.$route.name,
            query: {
                activeOffset: "0",
                records: "15"
            }
        });
    },
    methods: {
        copyReference(){
            let text = this.$store.state.currentOrg.org.applicationURL+'?isp='+this.organisation.reference
            navigator.clipboard.writeText(text)
            this.snackbar = true
        },
        async initialise() {
            this.getOrganisationDetails()
            this.fetchDocuments()
            this.fetchGlobalIspPackages()
            this.fetchNetworkPackages()
        },
        exportActiveData() {
            Api()
                .get("/supplier/serviceAccounts/AllActive/oneDevice/export/" + this.$route.params.customerOrganisationId).then(response => {
                    var hiddenElement = document.createElement('a');
                    hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(response.data);
                    hiddenElement.target = '_blank';
                    hiddenElement.download = 'active_Service_Accounts.csv';
                    hiddenElement.click();
                })
        },
        fetchDocuments() {
            Api()
                .get("/upload/byCustomerOrganisation/" + this.$route.params.customerOrganisationId)
                .then((res) => {
                    this.documents = res.data;
                });
        },
        formatDate(date) {
            if (date !== null) {
                return dateformat(date, "yyyy-mm-dd");
            } else {
                null;
            }
        },
        getOrganisationDetails() {
            Api()
                .get("/organisation/basic/" + this.$route.params.customerOrganisationId)
                .then((response) => {
                    this.organisation = response.data;
                });
        },
        fetchGlobalIspPackages() {
            Api()
                .get("/supplier/packagesIsp/globalPackages/" + this.$route.params.customerOrganisationId)
                .then((response) => {
                    this.globalIspPackages = response.data;
                    this.key += 1;
                });
        },
        fetchNetworkPackages() {
            Api()
                .get("/supplier/packagesIsps/basic/active/" + this.$route.params.customerOrganisationId)
                .then((response) => {
                    this.networkIspPackages = response.data;
                    this.key += 1;
                });
        },
        async routerLinkToDetails(item) {
      if(!item.serviceAccountId){
      this.$router.push({ path: "/serviceAccounts/" + item.id });

      } else {
      this.$router.push({ path: "/serviceAccounts/" + item.serviceAccountId });

      }
    }
    }
}
</script>
